import { motion } from 'framer-motion';
import React, { useContext, useMemo } from 'react';
import { PageDimmerContext } from '../../cnr/contexts/PageDimmerContext';
import MotionWait from '../../motions/MotionWait';

const _loaderTypes = {
  dot: 'dot',
  circle: 'circle',
  dots: 'dots',
};

const PageDimmer = () => {

  const loaderType = _loaderTypes.circle;

  // Get context state
  const pageDimmerContext = useContext(PageDimmerContext);
  const { pageDimmer_state } = pageDimmerContext ?? {};
  const { pageDimmerOn, dimmer_page } = pageDimmer_state ?? {};
  const { dimmerDuration } = dimmer_page ?? {};

  // Memoize the loader component
  const loader = useMemo(() => {
    switch (loaderType) {
      case _loaderTypes.circle:
        return <MotionWait startType="page-dimmer" origin={'PageDimmer'} />;
      default:
        return null;
    }
  }, [loaderType]);

  // Memoize the dimmer component
  const dimmer = useMemo(
    () => (
      <motion.div
        className="page-dimmer"
        initial={{ opacity: 1 }}
        animate={{ opacity: pageDimmerOn ? 0 : 0 }}
        exit={{ opacity: 0, display: 'none' }}
        transition={{ opacity: { duration: dimmerDuration } }}
      >
        {loader}
      </motion.div>
    ),
    [pageDimmerOn, loader]
  );

  return dimmer;
};

export default PageDimmer;
